import { render, staticRenderFns } from "./AiproxyProviderLabel.vue?vue&type=template&id=daea755e&scoped=true"
import script from "./AiproxyProviderLabel.vue?vue&type=script&lang=js"
export * from "./AiproxyProviderLabel.vue?vue&type=script&lang=js"
import style0 from "./AiproxyProviderLabel.vue?vue&type=style&index=0&id=daea755e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daea755e",
  null
  
)

export default component.exports